import Vue from 'vue'
import Router from 'vue-router'
//views
import Home from '../views/Home.vue'
import Quiz from '../views/Quiz.vue'
import Ask from '../views/Ask.vue'
import LoginView from '../views/LoginView.vue'
import Emoji from '../views/Emoji.vue'
import Connection from '../views/Connection.vue'
import Quantities from '../views/Quantities.vue'

import { TokenService } from '../services/storage.service'
import ConnectionService  from '../services/connection.service'

import store from '../store'


Vue.use(Router)

const router =  new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        //notNeedInternetConnection: true,  // Allow access to even if not internet
      }
    }, {
      path: '/quiz/:quiz_id?',
      name: 'quiz',
      component: Quiz,
      meta: {
        //notNeedInternetConnection: true,  // Allow access to even if not internet
      }
    },
    {
      path: '/login',
      name: 'login',
      component: LoginView,
      meta: {
        public: true,  // Allow access to even if not logged in
        onlyWhenLoggedOut: true,
        //notNeedInternetConnection: true,  // Allow access to even if not internet
      }
    },
    {
      path: '/ask/:quiz_id/:theme_id',
      name: 'ask',
      meta: {
        //notNeedInternetConnection: true,  // Allow access to even if not internet
      },
      component: Ask,
    },
    {
      path: '/emoji',
      name: 'emoji',
      meta: {
        //notNeedInternetConnection: true,  // Allow access to even if not internet
      },
      component: Emoji,
    },{
      path: '/quantities',
      name: 'quantities',
      meta: {
        //notNeedInternetConnection: true,  // Allow access to even if not internet
      },
      component: Quantities,
    },{
      path: '/connection',
      name: 'connection',
      meta: {
        notNeedInternetConnection: true,  // Allow access to even if not internet
      },
      component: Connection,
    }
  ]
})

router.beforeEach((to, from, next) => {

  const isPublic = to.matched.some(record => record.meta.public)
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)

  const needInternetConnection = to.matched.some(record => !record.meta.notNeedInternetConnection)

  const loggedIn = !!TokenService.getToken();

  if (!isPublic && !loggedIn) {
    return next({
      path:'/login',
      query: {redirect: to.fullPath}  // Store the full path to redirect the user to after login
    });
  }

  // Do not allow user to visit login page or register page if they are logged in
  if (loggedIn && onlyWhenLoggedOut) {
    return next('/')
  }

  //if route need internet connection
  if(needInternetConnection){
    //check net status
    ConnectionService.handleConnection(false);
    // Do not allow user to visit page that need Internet connection
    if(!store.getters.hasInternetConnection){
      return next('/connection')
    }
  }

  next();
})


export default router;
